"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const FormalReviewClient_1 = require("client/FormalReviewClient");
const ToastContext_1 = require("context/ToastContext");
const HelperUtils_1 = require("utils/HelperUtils");
const HeaderPage_1 = __importDefault(require("components/admin/HeaderPage"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const Tabs_1 = __importDefault(require("components/design-system/tabs/Tabs"));
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const Footer_1 = __importDefault(require("components/shared/Footer"));
const helperClient_1 = require("src/client/helperClient");
const RevieweeFoundContent_1 = __importDefault(require("./RevieweeFoundContent"));
const RevieweeNotFoundContent_1 = __importDefault(require("./RevieweeNotFoundContent"));
const ChangeReviewer = () => {
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [currentStep, setCurrentStep] = (0, react_1.useState)('confirmation');
    const [currentTab, setCurrentTab] = (0, react_1.useState)('1');
    const [metaData, setMetaData] = (0, react_1.useState)(null);
    const { id } = (0, react_router_1.useParams)();
    const foundCount = metaData
        ? metaData.userChanged + metaData.userUnchanged
        : 0;
    const notFoundCount = metaData ? metaData.userNotFound : 0;
    const submitChanges = () => {
        setIsLoading(true);
        setCurrentStep('submitted');
        (0, helperClient_1.progressClientMiddleware)({
            queryFn: () => (0, FormalReviewClient_1.bulkChangeReviewer)(id),
            socketCallback: (data, listener) => {
                if (data.type == 'bulk_update_assignments_reviewer') {
                    if (data?.object) {
                        addToast({
                            id: data?.object?.cycleId,
                            title: (0, HelperUtils_1.getObjectiveLocale)('Reviewer changed successfully'),
                            msg: (0, HelperUtils_1.getObjectiveLocale)('New reviewers have been successfully updated.'),
                            type: 'success',
                            disabledAutoClose: true
                        });
                        setShowModal(false);
                        setTimeout(() => {
                            history.back();
                        }, 5000);
                        listener.unregister();
                    }
                    else if (data?.errors) {
                        addToast({
                            msg: (0, HelperUtils_1.getObjectiveLocale)('Something went wrong. Please try again'),
                            type: 'error'
                        });
                    }
                    setIsLoading(false);
                }
            }
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HeaderPage_1.default, { titlePage: (0, HelperUtils_1.getObjectiveLocale)('Change Reviewer'), isHeaderComposer: true, closeAction: () => history.back() }),
        react_1.default.createElement("div", { className: "px-40 pb-[64px]" },
            react_1.default.createElement("p", { className: "typography-h500 mb-[34px] mt-[30px] text-n-900" }, (0, HelperUtils_1.getObjectiveLocale)('Summary')),
            react_1.default.createElement("div", { className: "flex flex-col gap-[16px]" },
                metaData && (react_1.default.createElement(BannerBox_1.default, { text: `${foundCount} reviewees found in this cycle, ${notFoundCount} reviewees not found`, type: "info", withIcon: false, customClass: "w-full" })),
                react_1.default.createElement(Tabs_1.default, { currentTab: currentTab },
                    react_1.default.createElement(Tabs_1.default.Buttons, { fullWidth: true },
                        react_1.default.createElement(Tabs_1.default.Button, { id: "1", onClick: () => setCurrentTab('1'), badge: foundCount, withCount: !!metaData }, (0, HelperUtils_1.getObjectiveLocale)('Reviewees found')),
                        react_1.default.createElement(Tabs_1.default.Button, { id: "3", onClick: () => setCurrentTab('3'), badge: notFoundCount, withCount: !!metaData }, (0, HelperUtils_1.getObjectiveLocale)('Reviewees not found')))),
                currentTab == '1' && (react_1.default.createElement(RevieweeFoundContent_1.default, { phases: metaData?.phases ?? [], setMetaData: !metaData ? setMetaData : null })),
                currentTab == '3' && react_1.default.createElement(RevieweeNotFoundContent_1.default, null))),
        react_1.default.createElement(Footer_1.default, { linkButtonName: (0, HelperUtils_1.getObjectiveLocale)('Back'), secondaryButton: true, buttonPrimaryName: "Submit Changes", buttonPrimaryDisabled: (metaData?.userChanged ?? 0) == 0, handleClick: () => {
                setShowModal(true);
            }, handleRoute: () => history.back(), datacy: "" }),
        showModal && (react_1.default.createElement(Modal_1.default, { onClose: () => setShowModal(false), customClass: "w-[600px]" },
            react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)(currentStep == 'confirmation' ? 'Proceed?' : 'Change Reviewer'), onClose: () => setShowModal(false) }),
            react_1.default.createElement(Modal_1.default.Body, { customClass: "px-[24px]" }, currentStep == 'confirmation' ? (react_1.default.createElement("span", { className: "typography-paragraph text-n-800" },
                (0, HelperUtils_1.getObjectiveLocale)('Are you sure you want to save these changes?'),
                react_1.default.createElement("br", null),
                (0, HelperUtils_1.getObjectiveLocale)('Once the changes are applied, any submitted assignments from current reviewers will be deleted.'))) : (react_1.default.createElement(BannerBox_1.default, { text: (0, HelperUtils_1.getObjectiveLocale)('Submitting changes is in progress. Please do not close this tab browser. We will notify you once the importing process is done.'), type: "info", customClass: "w-full" }))),
            react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                    text: (0, HelperUtils_1.getObjectiveLocale)('Submit Changes'),
                    onClick: () => {
                        submitChanges();
                    },
                    isLoading: isLoading,
                    disabled: isLoading,
                    dataCy: 'submit-changes'
                }, secondaryButton: currentStep == 'confirmation'
                    ? {
                        text: (0, HelperUtils_1.getObjectiveLocale)('Cancel'),
                        onClick: () => setShowModal(false),
                        dataCy: 'back'
                    }
                    : undefined, useBorder: false })))));
};
exports.default = ChangeReviewer;
